import React from 'react';

const RUNES = 'ᚠᚢᚦᚨᚱᚲᚷᚹᚺᚾᛁᛃ';
function RuneRing() {
  return (
    <div className="btn-rune-ring">
      {RUNES.split('').map((r, i) => {
        const angle = (i / 12) * Math.PI * 2;
        const x = Math.cos(angle) * 36 + 34;
        const y = Math.sin(angle) * 36 + 34;
        return <span key={i} style={{ left: x, top: y }}>{r}</span>;
      })}
    </div>
  );
}

export default function ActionBar({ onCommand, onPrefill, onStartTargeting, onOpenRadar, onOpenSpellbook, isProPlus, isPro, hasBasicCombat, isDM, isMyTurn }) {
  if (!hasBasicCombat) return null;
  const disabled = !isMyTurn && !isDM;
  const Lock = () => <span className="plan-lock">🔒</span>;
  const locked = (requiredPlan) => !requiredPlan;
  return (
    <div className="action-bar">
      {isDM && <div className="action-group battle-sequence">
        <div className="group-btns">
          <div className="quick-btn battle-btn btn-numbered" onClick={() => onCommand('!f')}><RuneRing /><span className="btn-watermark">1</span><span className="emoji">🔥</span>Initiate</div>
          <div className="quick-btn battle-btn btn-numbered" onClick={() => onPrefill('!sp ')}><RuneRing /><span className="btn-watermark">2</span><span className="emoji">👹</span>Spawn</div>
        </div>
        <span className="group-label">⚔️ BATTLE SEQUENCE</span>
      </div>}
      <div className="action-group group-combat">
        <div className="group-btns">
          <div className={`quick-btn ${disabled ? 'disabled' : ''}`} onClick={() => !disabled && onCommand('!target')}><RuneRing /><span className="emoji">🎯</span>Attack</div>
          <div className={`quick-btn ${disabled ? 'disabled' : ''}`} onClick={() => !disabled && onPrefill('!cast ')}><RuneRing /><span className="emoji">✨</span>Cast</div>
          {isDM && <div className="quick-btn" onClick={() => onPrefill('!inflict ')}><RuneRing /><span className="emoji">😈</span>Afflict</div>}
          {isDM && <div className="quick-btn" onClick={() => onPrefill('!dmhit ')}><RuneRing /><span className="emoji">🩸</span>Smite</div>}
          <div className={`quick-btn ${!isProPlus ? 'plan-locked' : ''}`} onClick={() => isProPlus && onOpenRadar}><RuneRing /><span className="emoji">📡</span>Radar{!isProPlus && <Lock />}</div>
          {isDM && <div className="quick-btn" onClick={() => onCommand('!skip')}><RuneRing /><span className="emoji">⏩</span>Skip</div>}
          {isDM && <div className="quick-btn" onClick={() => onCommand('!q')}><RuneRing /><span className="emoji">🏳️</span>End</div>}
        </div>
        <span className="group-label">🎯 COMBAT</span>
      </div>
      <div className={`action-group group-dm-powers ${!isPro ? 'group-locked' : ''}`}>
        <div className="group-btns">
          <div className={`quick-btn ${!isPro ? 'plan-locked' : ''}`} onClick={() => isPro && onStartTargeting('!dmheal ')}><RuneRing /><span className="emoji">🤲</span>Lay Hands{!isPro && <Lock />}</div>
          <div className={`quick-btn ${!isPro ? 'plan-locked' : ''}`} onClick={() => isPro && onStartTargeting('!give ')}><RuneRing /><span className="emoji">🎁</span>Bestow{!isPro && <Lock />}</div>
          <div className={`quick-btn ${!isPro ? 'plan-locked' : ''}`} onClick={() => isPro && onPrefill('!removecondition ')}><RuneRing /><span className="emoji">💊</span>Cleanse{!isPro && <Lock />}</div>
          <div className={`quick-btn ${!isPro ? 'plan-locked' : ''}`} onClick={() => isPro && onCommand('!lr')}><RuneRing /><span className="emoji">🌙</span>Long Rest{!isPro && <Lock />}</div>
          <div className="quick-btn" onClick={() => onCommand('!sr')}><RuneRing /><span className="emoji">☀️</span>Short Rest</div>
        </div>
        <span className="group-label">✋ DM POWERS{!isPro && <span className="lock-badge">PRO</span>}</span>
      </div>
      <div className="action-group group-utilities">
        <div className="group-btns">
          <div className="quick-btn" onClick={onOpenSpellbook}><RuneRing /><span className="emoji"><img src="spellbook.gif" className="campaign-icon" alt="" style={{width:'1.4em',height:'1.4em',verticalAlign:'middle'}} /></span>Spellbook</div>
        </div>
        <span className="group-label">🧰 UTILITIES</span>
      </div>
    </div>
  );
}
